import Swiper from "swiper";

class Cart {
  constructor() {
    this.navSlider();
  }

  navSlider = () => {
    const slider = new Swiper(".js-checkout-swiper", {
      slidesPerView: "auto",
    });
  };
}

export default Cart;
new Cart();
